import { ProductHome as ProductHomeAK } from '@atlaskit/atlassian-navigation';
import { AtlassianIcon, AtlassianLogo } from '@atlaskit/logo';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { onSmallDesktopDown } from '../../../mobile/responsive';

const ProductHome = styled(ProductHomeAK)`
  margin-left: 4px !important;
  ${onSmallDesktopDown(`
    margin-left: 0px !important;
    svg {
      margin-top: 0px !important;
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
  `)}
`;

const NavAtlassianHome = () => {
  const history = useHistory();
  const handleOnClick = useCallback(() => history.push('/'), [history]);

  return <ProductHome onClick={handleOnClick} icon={AtlassianIcon} logo={AtlassianLogo} />;
};

export default NavAtlassianHome;
